import { render, staticRenderFns } from "./SipSessions.vue?vue&type=template&id=2b948ca7&"
import script from "./SipSessions.vue?vue&type=script&lang=js&"
export * from "./SipSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports